import { DEFAULT_EMPTY_VALUE } from '../constants';
import { PATROL_STATUS, PATROL_TYPE } from '../constants/patrol';
import { convertIdToValue } from '../details';

export const getStatusValue = list => {
  return convertIdToValue({
    list,
    key: 'currentStatus',
    constant: PATROL_STATUS,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const allowedPatrolEvidence = Object.values(PATROL_TYPE).reduce(
  (acc, item) => (item.allowTaskEvidence ? [...acc, item.id] : acc),
  [],
);
